module.exports = __webpack_public_path__ + "img/MES2.33865475.png";